import { createSelector } from 'reselect';

export const getComponentState = state => state.adminPromotionalItems;

export const getPromotionalItems = createSelector(
    getComponentState,
    (state) => state.promotionalItems
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getIsRejecting = createSelector(
    getComponentState,
    (state) => state.isRejecting
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getPromotionalItem = createSelector(
    getComponentState,
    (state) => state.promotionalItem
);
export const getImageFile = createSelector(
    getComponentState,
    (state) => state.imageFile
);
export const getDepartments = createSelector(
    getComponentState,
    (state) => state.departments
);
export const getIsDeleting = createSelector(
    getComponentState,
    (state) => state.isDeleting
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getIsUploading = createSelector(
    getComponentState,
    (state) => state.isUploading
);
export const getUploadFile = createSelector(
    getComponentState,
    (state) => state.uploadFile
);